import {Component, OnInit} from '@angular/core';
import {Objecttype, ObjecttypeCategory, ObjecttypeGroup, ObjecttypeSubgroup} from 'src/app/models/Objecttype';
import {AdminService} from 'src/app/services/admin.service';
import {MediaMatcher} from '@angular/cdk/layout';
import {environment} from 'src/environments/environment';
import {Router} from '@angular/router';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {IdService} from 'src/app/services/id.service';
import {ConfirmComponent} from 'src/app/components/common/bottom-sheet/confirm/confirm.component';
import {SnackbarService} from 'src/app/services/snackbar.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';


@Component({
  selector: 'app-objecttype',
  templateUrl: './objecttype.component.html',
  styleUrls: ['./objecttype.component.css'],
})
export class ObjecttypeComponent implements OnInit {
  objecttype: Objecttype;
  isLoading = true;
  objecttypecategories: ObjecttypeCategory[];
  groups: ObjecttypeGroup[] = [];
  subgroups: ObjecttypeSubgroup[] = [];
  editcategory = false;
  editgroup = false;
  editsubgroup = false;
  mobileQuery: MediaQueryList;
  idserviceobjecttype: string; // { version: string; id: string };
  FormEnName = new UntypedFormGroup({
    enName: new UntypedFormControl('', [Validators.required]),
  });
  editEnName = false;
  private ngUnsubscribe = new Subject();

  constructor(
    idservice: IdService,
    private adminservice: AdminService,
    private bottomSheet: MatBottomSheet,
    private router: Router,
    media: MediaMatcher,
    private snackbarservice: SnackbarService
  ) {
    adminservice
      .getCategories()
      .subscribe((categories: ObjecttypeCategory[]) => {
        this.objecttypecategories = categories; // .objecttypecategories;
      });
    adminservice
      .getGroups()
      .subscribe((groups: ObjecttypeGroup[]) => {
        this.groups = groups;
      });
    adminservice
      .getSubgroups()
      .subscribe((subgroups: ObjecttypeSubgroup[]) => {
        this.subgroups = subgroups;
      });
    // this.idserviceobjecttype = idservice.objecttypeId();
    adminservice
      .getObjectType(
        idservice.objecttypeId()
        // this.idserviceobjecttype.version,
        // this.idserviceobjecttype.id
      )
      .subscribe((objecttype) => {
        this.objecttype = objecttype;
        this.isLoading = false;
      });
    this.mobileQuery = media.matchMedia(environment.mobileQueryMaxwidthSmall);
  }

  get enName() {
    return this.FormEnName.get('enName');
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }


  toggleEditEnName() {
    this.editEnName = !this.editEnName;
    this.FormEnName.patchValue({
      enName: this.objecttype.enName,
    });
  }

  async saveEnName(enName: string) {
    this.objecttype.enName = enName;
    await this.adminservice.updateObjecttype(this.objecttype);
    this.editEnName = false;
  }

  toggleEditCategory() {
    this.editcategory = !this.editcategory;
  }

  toggleEditGroup() {
    this.editgroup = !this.editgroup;
  }

  toggleEditSubgroup() {
    this.editsubgroup = !this.editsubgroup;
  }

  // Groups belonging to the selected category
  get availableGroups(): ObjecttypeGroup[] {
    if (!this.objecttype || !this.objecttype.category) {
      return [];
    }
    return this.groups.filter((g) => g.categoryid === this.objecttype.category.id);
  }

  // Subgroups belonging to the selected group
  get availableSubgroups(): ObjecttypeSubgroup[] {
    if (!this.objecttype || !this.objecttype.group) {
      return [];
    }
    return this.subgroups.filter((s) => s.groupid === this.objecttype.group.id);
  }

  async onSelectionChange(category: ObjecttypeCategory) {
    this.objecttype.category = category;
    // Changing the category invalidates the group/subgroup below it
    this.objecttype.group = null;
    this.objecttype.subgroup = null;
    await this.adminservice.updateObjecttype(this.objecttype);
    this.editcategory = false;
  }

  async onSelectGroup(group: ObjecttypeGroup) {
    this.objecttype.group = {id: group.id, name: group.name};
    // Changing the group invalidates the subgroup below it
    this.objecttype.subgroup = null;
    await this.adminservice.updateObjecttype(this.objecttype);
    this.editgroup = false;
  }

  async onSelectSubgroup(subgroup: ObjecttypeSubgroup) {
    this.objecttype.subgroup = {id: subgroup.id, name: subgroup.name};
    await this.adminservice.updateObjecttype(this.objecttype);
    this.editsubgroup = false;
  }

  async toggleActive() {
    // Treat undefined/true as active; only an explicit false means deactivated
    this.objecttype.active = this.objecttype.active === false;
    await this.adminservice.updateObjecttype(this.objecttype);
    this.snackbarservice.openSnackBar(
      this.objecttype.active === false ? 'Objekttype deaktivert' : 'Objekttype aktivert',
      ''
    );
  }

  deleteObjecttypeConfirm(): void {
    const sheet = this.bottomSheet.open(ConfirmComponent, {
      backdropClass: 'blur-dialog-backdrop',
      data: {
        title: 'Er du sikker?',
        text: 'Slette objekttype: ' + this.objecttype.name,
        yes: {
          name: 'Ja',
          icon: 'delete',
        },
        no: {
          name: 'Nei',
          icon: 'close',
        },
      },
    });
    sheet.afterDismissed().pipe(takeUntil(this.ngUnsubscribe)).subscribe((confirm) => {
      if (confirm) {
        this.adminservice
          .deleteObjecttype()
          .then(async () => {
            console.log('Objecttype deleted...');
            await this.router.navigateByUrl(
              '/a/objekttyper'
            );
            this.snackbarservice.openSnackBar('Objekttype slettet...', '');
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }
}
